import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";

function shorten(str, len) {
  var length = 0;
  var strArr = Array.from(str); // ES6的Array.from支持代理对的解析

  var strArrlen = strArr.length;
  var result = '';

  for (var i = 0; i < strArrlen; i++) {
    var item = strArr[i];
    length++;

    if (escape(item).length > 4) {
      // 中文或表情符编码后长度大于4，按两个字符的宽度计算
      length++;
    }

    result = result.concat(item);

    if (length >= len) {
      if (i === strArrlen - 1) {
        return result;
      }

      result = result.concat('...');
      return result;
    }
  }

  if (length < len) {
    return str;
  }
}

export default {
  name: 'Nick',
  props: {
    useJs: {
      type: Boolean,
      default: false
    },
    length: {
      type: Number,
      default: Infinity
    },
    maxWidth: {
      type: String,
      default: ''
    }
  },
  render: function render() {
    var h = arguments[0];
    var nickVnode = this.$slots.default[0];
    var nickText = this.useJs ? shorten(nickVnode.text, this.length) : nickVnode.text;
    var style = this.maxWidth ? {
      'max-width': this.maxWidth
    } : {};
    return h("span", {
      "class": "vft-nick",
      "style": style
    }, [nickText]);
  },
  shorten: shorten
};